import React from "react";

const Actions = ({ productQuantity, changeProductQuantity, calculatedTotalPrice }) => {
  return (
    <div className="action">
      <div className="buttons">
        <button onClick={() => changeProductQuantity(productQuantity - 1)}>-</button>
        <span className="quantity">{formatNumber(productQuantity)}</span>
        <button onClick={() => changeProductQuantity(productQuantity + 1)}>+</button>
      </div>
      <div className="total">
        <span>총 금액</span>
        <span>{formatNumber(calculatedTotalPrice)}원</span>
      </div>
    </div>
  );
};

export default Actions;
